export const HOURS = {
  0: '12am',
  1: '1am',
  2: '2am',
  3: '3am',
  4: '4am',
  5: '5am',
  6: '6am',
  7: '7am',
  8: '8am',
  9: '9am',
  10: '10am',
  11: '11am',
  12: '12pm',
  13: '1pm',
  14: '2pm',
  15: '3pm',
  16: '4pm',
  17: '5pm',
  18: '6pm',
  19: '7pm',
  20: '8pm',
  21: '9pm',
  22: '10pm',
  23: '11pm',
  24: '12am',
  25: '1am',
  26: '2am',
  27: '3am',
  28: '4am',
  29: '5am',
};

export const OVERNIGHT_HOUR_MAP = {
  24: 0,
  25: 1,
  26: 2,
  27: 3,
  28: 4,
  29: 5,
  30: 6,
  31: 7,
  32: 8,
  33: 9,
  34: 10,
  35: 11,
  36: 12,
  37: 13,
  38: 14,
  39: 15,
  40: 16,
  41: 17,
  42: 18,
  43: 19,
  44: 20,
};

export const FIRST_CELL_MIN_WIDTH = 280;

export const DEFAULT_CELL_HEIGHT = 24;

export const HOURS_IN_DAY = 24;
export const MAX_HOURS_IN_DAY_VIEW = Object.keys(HOURS).length;
